module.exports = __webpack_public_path__ + "_assets/img/scanalert.3bcc16db.png";